import { postFetch } from '../fetch';

import { apiConfig } from '../config';

interface StudentData {
    name?: string;
    grade?: number;
}

export function patchStudent(id: number, studentData: StudentData) {
    const { apiPatchStudent } = apiConfig.getStaticUrls();
    const { name, grade } = studentData;

    const newStudentData: Record<string, any> = {};

    if (name) {
        const [lastName, ...firstNameAr] = name.trim().split(' ');
        newStudentData.last_name = lastName;
        newStudentData.first_name = firstNameAr.join(' ');
    }

    if (grade) {
        newStudentData.student_profile = { grade };
    }

    return postFetch(
        `${apiPatchStudent}${id}/`,
        newStudentData
    );
}
